import { Building2, CheckCircle2, IdCard } from 'lucide-react';

export const ONBOARDING_PENDING_KEY = 'kibo:onboarding-pending';
export const DRAFT_STORAGE_KEY = 'kibo:org-onboarding-draft';

export const ORG_SIZES = [
  { value: '1-50', label: '1-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '201-1000', label: '201-1,000 employees' },
  { value: '1001+', label: '1,001+ employees' },
] as const;

export type CountryOption = { code: string; name: string; dial: string };

export const COUNTRIES: CountryOption[] = [
  { code: 'ET', name: 'Ethiopia', dial: '+251' },
  { code: 'KE', name: 'Kenya', dial: '+254' },
  { code: 'UG', name: 'Uganda', dial: '+256' },
  { code: 'TZ', name: 'Tanzania', dial: '+255' },
  { code: 'RW', name: 'Rwanda', dial: '+250' },
  { code: 'DJ', name: 'Djibouti', dial: '+253' },
  { code: 'SO', name: 'Somalia', dial: '+252' },
  { code: 'SD', name: 'Sudan', dial: '+249' },
  { code: 'SS', name: 'South Sudan', dial: '+211' },
  { code: 'EG', name: 'Egypt', dial: '+20' },
  { code: 'NG', name: 'Nigeria', dial: '+234' },
  { code: 'ZA', name: 'South Africa', dial: '+27' },
  { code: 'GH', name: 'Ghana', dial: '+233' },
  { code: 'MA', name: 'Morocco', dial: '+212' },
  { code: 'TN', name: 'Tunisia', dial: '+216' },
  { code: 'AE', name: 'United Arab Emirates', dial: '+971' },
  { code: 'SA', name: 'Saudi Arabia', dial: '+966' },
  { code: 'TR', name: 'Turkey', dial: '+90' },
  { code: 'GB', name: 'United Kingdom', dial: '+44' },
  { code: 'US', name: 'United States', dial: '+1' },
  { code: 'CA', name: 'Canada', dial: '+1' },
  { code: 'DE', name: 'Germany', dial: '+49' },
  { code: 'FR', name: 'France', dial: '+33' },
  { code: 'NL', name: 'Netherlands', dial: '+31' },
  { code: 'IN', name: 'India', dial: '+91' },
  { code: 'CN', name: 'China', dial: '+86' },
  { code: 'JP', name: 'Japan', dial: '+81' },
];

export const STEPS = [
  { id: 1, title: 'Organization Details', short: 'Details', icon: Building2 },
  { id: 2, title: 'Contact Information', short: 'Contact', icon: IdCard },
  { id: 3, title: 'Review & Submit', short: 'Review', icon: CheckCircle2 },
] as const;

export type StepDefinition = (typeof STEPS)[number];

export const DESCRIPTION_MIN = 80;
export const DESCRIPTION_MAX = 1000;

export const URL_PATTERN = /^https?:\/\/[^\s]+\.[^\s]+/i;
export const PHONE_PATTERN = /^[0-9()\-\s]{6,20}$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const INPUT_BASE_CLASS =
  'h-12 bg-card text-[15px] text-foreground placeholder:text-muted-foreground border-border hover:border-primary/40 focus:border-primary focus-visible:border-primary focus-visible:ring-primary/20';
export const SELECT_TRIGGER_CLASS =
  'h-12 w-full bg-card text-[15px] text-foreground border-border hover:border-primary/40 hover:bg-card data-[placeholder]:text-muted-foreground';
export const SELECT_CONTENT_CLASS = 'bg-popover text-popover-foreground';
export const TEXTAREA_BASE_CLASS =
  'w-full rounded-md border bg-card px-3 py-2.5 text-[15px] text-foreground shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20';
